import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { FormArray, FormBuilder, FormGroup } from '@angular/forms'
import { NgxSpinnerService } from 'ngx-spinner'
import {
  RequestAddRateReceiver,
  RequestinvoiceheaderprefixUpdate,
  ResponseinvoicecustomerchargeSelect,
  ResponseinvoicecustomerchargeTotalSelect,
  ResponseinvoiceheaderprefixSelect,
  ResponseRateInvoiceNumber,
  ResponseReceivingChanges
} from 'src/app/_models'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'
import * as XLSX from 'xlsx'
@Component({
  selector: 'app-invoice-generate',
  templateUrl: './invoice-generate.component.html',
  styleUrls: ['./invoice-generate.component.css']
})
export class InvoiceGenerateComponent implements OnInit {
  dtoptions = {
    pagingType: 'full_numbers',
    pageLength: 1000,
    processing: true,
    scrollX: '100vw',
    scrollY: '70vh',
    dom: 'Bfrtip',
    order: [],
    buttons: [
      'colvis',
      'copy',
      {
        extend: 'csvHtml5',
        text: 'CSV',
        exportOptions: {
          modifier: {
            search: 'applied',
            selected: true
          },
          columns: ':visible'
        }
      },
      {
        extend: 'print',
        text: 'PDF',
        exportOptions: {
          modifier: {
            search: 'applied',
            selected: true
          },
          columns: ':visible'
        }
      }
    ],
    responsive: false
  }
  RequestAddRateReceiver: RequestAddRateReceiver
  RequestAddRateReceiverArray: RequestAddRateReceiver[]
  viewAddlistRate = false
  readonlyType = false
  invoiceexcelGenerar = false
  invoiceSearchView = false
  invoicechargesview = false
  invoicerateAddview = false
  invoicecollectionrateamount = []
  viewListInvoice = true
  labelbuttonCharges = 'Add'
  datosExport: any
  datosExportInvoice: any
  datosSearchReceiver = []
  containerList = []
  datosExportInvoiceReceiver: any
  arrayDatosChangeReceivinng = []
  Registro: any
  invoiceList = []
  selectInvoice: any
  IdEditNewChanges = 0
  IdChargesDescuento: any
  descuentoCharges = 0
  valorCustomerMasivo: any
  valorCustomerMasivo2: any
  valorCustomerMasivo3: any
  FormReceivingChanges: FormGroup
  valorTYPE = 'RECEIVE-GENERAL'
  valorTYPE2 = 'RECEIVE-GENERAL'
  valorTYPE3 = 'RECEIVE-GENERAL'

  labelInvoiceHeaderButton = 'Save'
  FormInvoiceHeader: FormGroup
  From: any
  To: any
  From2: any
  To2: any
  From3: any
  To3: any
  IdEditar = 0
  Customer = []
  idorder = 0
  idorderAddReceiver = ''
  invoiceheadergeneralSelect = []
  receiverIDList = []
  rateamountmanuallyselect = []
  ratemanual = false
  ratemanual2 = false
  valorTYPERate = '1'
  valorTYPERate2 = '1'
  valorTYPERate3 = '1'
  btnExport = false
  datosReceiverProducts = []
  formArrayDataRate: FormGroup
  dataResponseinvoiceheaderprefixSelect:ResponseinvoiceheaderprefixSelect;
  dataRequestinvoiceheaderprefixUpdate:RequestinvoiceheaderprefixUpdate;
  dataResponseinvoicecustomerchargeSelect:ResponseinvoicecustomerchargeTotalSelect;
  constructor (
    private spinner: NgxSpinnerService,
    private formbuider: FormBuilder,
    private _httpClient: HttpClient,
    private authenticationService: AuthenticationService
  ) {
    this.invoicecollectionrateamount = []
    this.datosReceiverProducts = []
    this.receiverIDList = []
    this.invoiceheadergeneralSelect = []
    this.arrayDatosChangeReceivinng = []
    this.rateamountmanuallyselect = []
    this.invoiceList = []
    this.Customer = []
    this.datosSearchReceiver = []
    this.containerList = []
    this.RequestAddRateReceiverArray = []
    this.OnSelectCostumer()
    this.spinner.show();
  setTimeout(() => {
    
    this.onChangeInvoiceGeneral()
    this.OnChangeInvoiceList()
    this.spinner.hide();
  }, 1200);
  }

  ngOnInit (): void {
    this.FormInvoiceHeader = this.formbuider.group({
      tipo: [0],
      id_order: [''],
      type_order: ['Receiving'],
      fromname: [''],
      fromstreet: [''],
      toname: [''],
      tostreet: [''],
      billname: [''],
      billstreet: [''],
      invoicenumber: [''],
      payterm: [''],
      customerid: [''],
      referencesnumber: [''],
      dateinvoice: [new Date(new Date())],
      totalamount: [''],
      noteinvoice: ['']
    })
    this.FormReceivingChanges = this.formbuider.group({
      invoiceListSelect: [''],
      priceUnit: [1],
      QuantityChanges: [1],
      TotalChangesR: [1],
      extra1: [''],
      extra2: [''],
      id: [0]
    })

    this.formArrayDataRate = this.formbuider.group({
      rateListForm: this.formbuider.array([])
    })

    try {
      $(document).on('keypress', '.TabOnEnterHeader', function (e) {
        //Only do something when the user presses enter
        if (e.keyCode == 13) {
          var nextElement = $('[tabindex="' + (this.tabIndex + 1) + '"]')
          console.log(this, nextElement)
          if (nextElement.length) nextElement.focus()
          else $('[tabindex="1"]').focus()
        }
      })
    } catch (error) {}
  }
  OnInvoiceHeaderInsert () {
    this.spinner.show();
    var Request = {
      tipo: Number(this.FormInvoiceHeader.controls.tipo.value),
      id_order: Number(this.IdEditar),
      type_order: String(this.valorTYPE),
      fromname: String(this.FormInvoiceHeader.controls.fromname.value),
      fromstreet: String(this.FormInvoiceHeader.controls.fromstreet.value),
      toname: String(this.FormInvoiceHeader.controls.toname.value),
      tostreet: String(this.FormInvoiceHeader.controls.tostreet.value),
      billname: String(this.FormInvoiceHeader.controls.billname.value),
      billstreet: String(this.FormInvoiceHeader.controls.billstreet.value),
      invoicenumber: String(
        this.FormInvoiceHeader.controls.invoicenumber.value||''
      ),
      payterm: String(this.FormInvoiceHeader.controls.payterm.value)||'',
      customerid: String(Number(this.valorCustomerMasivo)),
      referencesnumber: String(
        this.FormInvoiceHeader.controls.referencesnumber.value||''
      ),
      dateinvoice: this.FormInvoiceHeader.controls.dateinvoice.value || null,
      totalamount: String(
        this.FormInvoiceHeader.controls.totalamount.value || '0'
      ),
      noteinvoice: String(
        this.FormInvoiceHeader.controls.noteinvoice.value || ''
      ),
      companyID: Number(this.authenticationService.currentUserValue.companyIdWh)
    }

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/invoiceheaderisertupdate`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.spinner.hide();
       
        console.log(response)
       try {
        this.spinner.show();
        var resp = String(response.responses)
        if (resp.includes('success')) {
          this.readonlyType = true
          var spl = resp.replace('success-', '')
          this.idorder = Number(spl)
          this.labelInvoiceHeaderButton = 'Update'
          this.FormInvoiceHeader.controls.tipo.setValue(this.idorder)
          this.OnsaveTipoSearchInvoice();
          this.onChangeInvoiceGeneral()
          try {
            this.Onrateamountmanuallyselect(this.idorder)
          } catch (error) {}
          this.OnReceiverIDInvoiceList(this.idorder)
        } else if (resp.includes('update')) {
          this.readonlyType = true
          var spl = resp.replace('update-', '')
          this.idorder = Number(spl)
          this.labelInvoiceHeaderButton = 'Update'
          this.FormInvoiceHeader.controls.tipo.setValue(this.idorder)
          this.onChangeInvoiceGeneral()
          try {
            this.Onrateamountmanuallyselect(this.idorder)
          } catch (error) {}
          this.OnReceiverIDInvoiceList(this.idorder)
        }
        this.spinner.hide();
       } catch (error) {
        this.spinner.hide();
       }
      })
  }

  OnSelectCostumer () {
    var Request = {}
    Request['CompanyId'] = String(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['Active'] = String('1')

    this._httpClient
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization:
            'Bearer ' + this.authenticationService.currentUserValue.token
        })
      })
      .subscribe((response: any) => {
        this.Customer = response
      })
  }

  ExportReceive () {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/invoiceSearchExportData?tblCustomerID=${Number(
          this.valorCustomerMasivo3
        )}&tblCompanyID=${
          this.authenticationService.currentUserValue.companyIdWh
        }&from=${new Date(new Date(this.From3)).toISOString()}&to=${new Date(
          new Date(this.To3)
        ).toISOString()}&id_order=${this.idorder}&type_order=${
          this.valorTYPE3
        }&typeRate=${Number(this.valorTYPERate3)}&typeRate2=${Number(
          this.valorTYPERate
        )}&type_order2=${this.valorTYPE}&from2=${new Date(
          new Date(this.From)
        ).toISOString()}&to2=${new Date(new Date(this.To)).toISOString()}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.datosExport = response
        console.log(this.datosExport)
        this.exportAsExcel(this.datosExport.invoiceGeneralRequest)
      })
  }
  exportAsExcel (data: any) {
    var arr1 = {}
    var it = 0
    for (let index = 0; index < data.length; index++) {
      const element = data[index]

      try {
        var a0 = {}
        var b0 = {}
        var c0 = {}
        var d0 = {}
        var e0 = {}
        var f0 = {}
        var g0 = {}
        var h0 = {}
        var i0 = {}
        var j0 = {}
        var k0 = {}
        var l0 = {}
        var m0 = {}
        var n0 = {}
        var o0 = {}
        var p0 = {}
        var q0 = {}
        var r0 = {}
        a0['t'] = 's'
        a0['v'] = 'RECEIVER#'

        b0['t'] = 's'
        b0['v'] = 'CUSTOMER'

        c0['t'] = 's'
        c0['v'] = 'ITEMNUMBER'

        d0['t'] = 's'
        d0['v'] = 'DESCRIPTION'

        e0['t'] = 's'
        e0['v'] = 'UNIT'
        f0['t'] = 's'
        f0['v'] = 'PALLET#'
        g0['t'] = 's'
        g0['v'] = 'PALLET'
        h0['t'] = 's'
        h0['v'] = 'QUANTITY'
        i0['t'] = 's'
        i0['v'] = 'TOTAL'
        j0['t'] = 's'
        j0['v'] = 'RATE'
        k0['t'] = 's'
        k0['v'] = 'AMOUNT'
        l0['t'] = 's'
        l0['v'] = 'PO#'
        m0['t'] = 's'
        m0['v'] = 'RECEIVED'
        n0['t'] = 's'
        n0['v'] = 'CARRIER'
        o0['t'] = 's'
        o0['v'] = 'CONTAINER#'
        p0['t'] = 's'
        p0['v'] = 'REFERENCE#'
        q0['t'] = 's'
        q0['v'] = 'BOL#'
        r0['t'] = 's'
        r0['v'] = 'NOTE'
        it += 2
        arr1['A' + it] = a0
        arr1['B' + it] = b0
        arr1['C' + it] = c0
        arr1['D' + it] = d0
        arr1['E' + it] = e0
        arr1['F' + it] = f0
        arr1['G' + it] = g0

        arr1['H' + it] = h0
        arr1['I' + it] = i0
        arr1['J' + it] = j0
        arr1['K' + it] = k0
        arr1['L' + it] = l0
        arr1['M' + it] = m0
        arr1['N' + it] = n0
        arr1['O' + it] = o0
        arr1['P' + it] = p0
        arr1['Q' + it] = q0
        arr1['R' + it] = r0
      } catch (error) {}
      var to = 0
      try {
        to = element.responseInvoiceItemsManuallity.length
        to -= 1
      } catch (error) {}
      var pallet = 0
      var rate = 0
      var quantity = 0
      var palletNumber = 0
      var total = 0
      var amount = 0

      try {
        for (
          let index2 = 0;
          index2 < element.responseInvoiceItemsManuallity.length;
          index2++
        ) {
          var elemetR = element.responseInvoiceItemsManuallity[index2]

          try {
            var a = {}
            var b = {}
            var c = {}
            var d = {}
            var e = {}
            var f = {}
            var g = {}
            var h = {}
            var i = {}
            var j = {}
            var k = {}
            var l = {}
            var m = {}
            var n = {}
            var o = {}
            var p = {}

            var q = {}
            var r = {}

            a['t'] = 's'
            a['v'] = String(elemetR.idReceiving)
            b['t'] = 's'
            b['v'] = String(elemetR.customer)
            c['t'] = 's'
            c['v'] = String(elemetR.itemNumber)
            d['t'] = 's'
            d['v'] = String(elemetR.description)

            e['t'] = 's'
            e['v'] = String(elemetR.type_pallets)

            f['t'] = 'n'
            f['v'] = Number(elemetR.rowPosition)
            g['t'] = 'n'
            pallet += Number(elemetR.pallets)
            g['v'] = Number(elemetR.pallets)
            h['t'] = 'n'
            quantity += Number(elemetR.piecesByPallet)
            h['v'] = Number(elemetR.piecesByPallet)
            i['t'] = 'n'
            total += Number(elemetR.total)
            i['v'] = Number(elemetR.total)
            j['t'] = 'n'
            rate += Number(elemetR.rateAmount)
            j['v'] = Number(elemetR.rateAmount)

            if (this.valorTYPE3 == 'RECEIVE-GENERAL') {
              amount += Number(elemetR.rateAmount) * Number(elemetR.pallets)
              k['t'] = 'n'
              k['v'] = Number(
                Number(elemetR.rateAmount) * Number(elemetR.pallets)
              )
            } else {
              amount +=
                Number(elemetR.rateAmount) * Number(elemetR.piecesByPallet)
              k['t'] = 'n'
              k['v'] = Number(
                Number(elemetR.rateAmount) * Number(elemetR.piecesByPallet)
              )
            }

            l['t'] = 's'
            l['v'] = String(elemetR.poNumber)
            m['t'] = 's'
            m['v'] = String(elemetR.received)
            n['t'] = 's'
            n['v'] = String(elemetR.carrierName)
            o['t'] = 's'
            o['v'] = String(elemetR.containerNumber)
            p['t'] = 's'
            p['v'] = String(elemetR.referenceNumber)
            q['t'] = 's'
            q['v'] = String(elemetR.bolNumber)
            r['t'] = 's'
            r['v'] = String(elemetR.notes)
            it += 1
            arr1['A' + it] = a
            arr1['B' + it] = b
            arr1['C' + it] = c
            arr1['D' + it] = d
            arr1['E' + it] = e
            arr1['F' + it] = f
            arr1['G' + it] = g
            arr1['H' + it] = h
            arr1['I' + it] = i
            arr1['J' + it] = j
            arr1['K' + it] = k
            arr1['L' + it] = l
            arr1['M' + it] = m
            arr1['N' + it] = n
            arr1['O' + it] = o
            arr1['P' + it] = p
            arr1['Q' + it] = q
            arr1['R' + it] = r
          } catch (error) {}
          if (to == index2) {
            try {
              var a = {}
              var b = {}
              var c = {}
              var d = {}
              var e = {}
              var f = {}
              var g = {}
              var h = {}
              var i = {}
              var j = {}
              var k = {}
              var l = {}
              var m = {}
              var n = {}
              var o = {}
              var p = {}

              var q = {}
              var r = {}

              a['t'] = 's'
              a['v'] = String(elemetR.idReceiving)
              b['t'] = 's'
              b['v'] = String('TOTAL')
              c['t'] = 's'
              c['v'] = ''
              d['t'] = 's'
              d['v'] = ''

              e['t'] = 's'
              e['v'] = ''

              f['t'] = 'n'
              var palletNumber = Number(elemetR.rowPosition)

              if (palletNumber == 0) {
                palletNumber = 1
                f['v'] = Number(to + 1)
              } else {
                f['v'] = Number(elemetR.rowPosition)
              }

              g['t'] = 'n'
              g['v'] = Number(pallet)
              h['t'] = 'n'
              h['v'] = Number(quantity)
              i['t'] = 'n'
              i['v'] = Number(total)
              j['t'] = 'n'
              j['v'] = Number(rate)

              k['t'] = 'n'
              k['v'] = Number(Number(amount))

              l['t'] = 's'
              l['v'] = ''
              m['t'] = 's'
              m['v'] = ''
              n['t'] = 's'
              n['v'] = ''
              o['t'] = 's'
              o['v'] = ''
              p['t'] = 's'
              p['v'] = ''
              q['t'] = 's'
              q['v'] = ''
              r['t'] = 's'
              r['v'] = ''
              it += 1
              arr1['A' + it] = a
              arr1['B' + it] = b
              arr1['C' + it] = c
              arr1['D' + it] = d
              arr1['E' + it] = e
              arr1['F' + it] = f
              arr1['G' + it] = g
              arr1['H' + it] = h
              arr1['I' + it] = i
              arr1['J' + it] = j
              arr1['K' + it] = k
              arr1['L' + it] = l
              arr1['M' + it] = m
              arr1['N' + it] = n
              arr1['O' + it] = o
              arr1['P' + it] = p
              arr1['Q' + it] = q
              arr1['R' + it] = r
            } catch (error) {}

            console.log('ultimo')
          }
        }
      } catch (error) {}

      try {
        try {
          var a0 = {}
          var b0 = {}
          var c0 = {}
          var d0 = {}
          var e0 = {}
          var f0 = {}
          var g0 = {}
          var h0 = {}
          var i0 = {}
          var j0 = {}
          var k0 = {}
          var l0 = {}
          var m0 = {}
          var n0 = {}
          var o0 = {}
          var p0 = {}
          var q0 = {}
          var r0 = {}
          a0['t'] = 's'
          a0['v'] = 'RECEIVER#'

          b0['t'] = 's'
          b0['v'] = ''

          c0['t'] = 's'
          c0['v'] = ''

          d0['t'] = 's'
          d0['v'] = 'CHARGES'

          e0['t'] = 's'
          e0['v'] = 'PRICE'
          f0['t'] = 's'
          f0['v'] = 'QUANTITY'
          g0['t'] = 's'
          g0['v'] = 'TOTAL'
          h0['t'] = 's'
          h0['v'] = ''
          i0['t'] = 's'
          i0['v'] = ''
          j0['t'] = 's'
          j0['v'] = ''
          k0['t'] = 's'
          k0['v'] = ''
          l0['t'] = 's'
          l0['v'] = ''
          m0['t'] = 's'
          m0['v'] = ''
          n0['t'] = 's'
          n0['v'] = ''
          o0['t'] = 's'
          o0['v'] = ''
          p0['t'] = 's'
          p0['v'] = ''
          q0['t'] = 's'
          q0['v'] = ''
          r0['t'] = 's'
          r0['v'] = ''
          it += 1
          arr1['A' + it] = a0
          arr1['B' + it] = b0
          arr1['C' + it] = c0
          arr1['D' + it] = d0
          arr1['E' + it] = e0
          arr1['F' + it] = f0
          arr1['G' + it] = g0

          arr1['H' + it] = h0
          arr1['I' + it] = i0
          arr1['J' + it] = j0
          arr1['K' + it] = k0
          arr1['L' + it] = l0
          arr1['M' + it] = m0
          arr1['N' + it] = n0
          arr1['O' + it] = o0
          arr1['P' + it] = p0
          arr1['Q' + it] = q0
          arr1['R' + it] = r0
        } catch (error) {}
        for (
          let index = 0;
          index < element.responseChargesInvoiceGeneral.length;
          index++
        ) {
          const element2 = element.responseChargesInvoiceGeneral[index]

          try {
            var a = {}
            var b = {}
            var c = {}
            var d = {}
            var e = {}
            var f = {}
            var g = {}
            var h = {}
            var i = {}
            var j = {}
            var k = {}
            var l = {}
            var m = {}
            var n = {}
            var o = {}
            var p = {}

            var q = {}
            var r = {}

            a['t'] = 's'
            a['v'] = String(element2.tblID)
            b['t'] = 's'
            b['v'] = String('')
            c['t'] = 's'
            c['v'] = ''
            d['t'] = 's'
            d['v'] = String(
              element2.tblInvoiceListDescription +
                ' ' +
                element2.extra1 +
                ' ' +
                element2.extra2
            )

            e['t'] = 'n'
            e['v'] = Number(element2.unitPrice)

            f['t'] = 'n'

            f['v'] = Number(element2.quantity)

            g['t'] = 'n'
            g['v'] = Number(element2.total)
            h['t'] = 's'
            h['v'] = ''
            i['t'] = 's'
            i['v'] = ''
            j['t'] = 's'
            j['v'] = ''

            k['t'] = 's'
            k['v'] = ''

            l['t'] = 's'
            l['v'] = ''
            m['t'] = 's'
            m['v'] = ''
            n['t'] = 's'
            n['v'] = ''
            o['t'] = 's'
            o['v'] = ''
            p['t'] = 's'
            p['v'] = ''
            q['t'] = 's'
            q['v'] = ''
            r['t'] = 's'
            r['v'] = ''
            it += 1
            arr1['A' + it] = a
            arr1['B' + it] = b
            arr1['C' + it] = c
            arr1['D' + it] = d
            arr1['E' + it] = e
            arr1['F' + it] = f
            arr1['G' + it] = g
            arr1['H' + it] = h
            arr1['I' + it] = i
            arr1['J' + it] = j
            arr1['K' + it] = k
            arr1['L' + it] = l
            arr1['M' + it] = m
            arr1['N' + it] = n
            arr1['O' + it] = o
            arr1['P' + it] = p
            arr1['Q' + it] = q
            arr1['R' + it] = r
          } catch (error) {}
        }
      } catch (error) {}

      /* arr1["G"+index+1]=String()
  arr1["H"+index+1]=String()
  arr1["I"+index+1]=String()
  arr1["J"+index+1]=String()
  arr1["K"+index+1]=String()

  arr1["L"+index+1]=String()
  arr1["M"+index+1]=String()
  arr1["Ñ"+index+1]=String()
  arr1["0"+index+1]=String()
  arr1["P"+index+1]=String()
  arr1["Q"+index+1]=String()
  arr1["R"+index+1]=String()
  arr1["S"+index+1]=String()
  arr1["T"+index+1]=String() */

      /*  var a2 = {}
      var b2 = {}
      var c2 = {}
      var d2 = {}
      var e2 = {}
      var f2 = {}

      a2['t'] = 's'
      a2['v'] = 'Quantity'

      b2['t'] = 's'
      b2['v'] = 'Item Number'

      c2['t'] = 's'
      c2['v'] = 'Description'

      d2['t'] = 's'
      d2['v'] = 'rate amount'

      e2['t'] = 's'
      e2['v'] = 'aumount'

      f2['t'] = 's'
      f2['v'] = 'Unit'

      it += 1
      arr1['D' + it] = a2
      arr1['E' + it] = b2
      arr1['F' + it] = c2
      arr1['G' + it] = d2
      arr1['H' + it] = e2
      arr1['I' + it] = f2
      var to = 0.0
      try {
        for (
          let index2 = 0;
          index2 < element.responseInvoiceGeneral.length;
          index2++
        ) {
          const element2 = element.responseInvoiceGeneral[index2]
          it += 1
          to += Number(element2.aumount)
          var a3 = {}
          var b3 = {}
          var c3 = {}
          var d3 = {}
          var e3 = {}
          var f3 = {}

          a3['t'] = 's'
          a3['v'] = String(element2.piecesByPallet)
          b3['t'] = 's'
          b3['v'] = String(element2.itemNumber)
          c3['t'] = 's'
          c3['v'] = String(element2.itemDescription)
          d3['t'] = 's'
          d3['v'] = String(element2.rateamount)
          e3['t'] = 's'
          e3['v'] = String(element2.aumount)
          f3['t'] = 's'
          f3['v'] = String(element2.type_pallets)

          arr1['D' + it] = a3
          arr1['E' + it] = b3
          arr1['F' + it] = c3
          arr1['G' + it] = d3
          arr1['H' + it] = e3
          arr1['I' + it] = f3
        }
      } catch (error) {}

      var j = {}
      var k = {}
      it += 1
      j['t'] = 's'
      j['v'] = 'Total'
      k['t'] = 's'
      k['v'] = String(to)
      arr1['J' + it] = j

      arr1['K' + it] = k */
    }

    arr1['!ref'] = 'A1:R' + it * 10
    arr1['!margins'] = {
      left: 0.7,
      right: 0.7,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3
    }
    arr1['!cols'] = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 }
    ] // set column A width to 10 character
    var wb1 = {
      SheetNames: ['Order'],
      Sheets: {
        Order: arr1
      }
    }

    console.log(wb1)

    //converts a DOM TABLE element to a worksheet

    /* save to file */
    XLSX.writeFile(wb1, 'receiveId.xlsx')
  }

  onChangedefault () {
    if (Number(this.valorCustomerMasivo) == 1264) {
      this.FormInvoiceHeader.controls.fromname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.fromstreet.setValue(
        String('1231 N MILLER STREET STE #150 ,ANAHEIM CA 93021')
      )
      this.FormInvoiceHeader.controls.toname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.tostreet.setValue(
        String('5942 EDIGER AVE. STE #113 ,HUNTINGTON BEACH CA 92649.')
      )
      this.FormInvoiceHeader.controls.billname.setValue(
        String('PENTAIR WATER POOL & SPA')
      )
      this.FormInvoiceHeader.controls.billstreet.setValue(
        String('10951 W LOS ANGELES AVE ,MOORPARK CA 93021')
      )
    } else if (Number(this.valorCustomerMasivo) == 1265) {
      this.FormInvoiceHeader.controls.fromname.setValue(
        String('LINE DRIVE TRUCKING, INC.')
      )
      this.FormInvoiceHeader.controls.fromstreet.setValue(
        String('1231 N MILLER STREET, STE #150 ,ANAHEIM CA 93021')
      )
      this.FormInvoiceHeader.controls.toname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.tostreet.setValue(
        String('5942 EDIGER AVE. STE #113 ,HUNTINGTON BEACH CA 92649.')
      )
      this.FormInvoiceHeader.controls.billname.setValue(
        String('PENTAIR WATER POOL & SPA')
      )
      this.FormInvoiceHeader.controls.billstreet.setValue(
        String('13950 MOUNTAIN AVENUE ,CHINO CA 91710')
      )
    } else if (Number(this.valorCustomerMasivo) == 355) {
      this.FormInvoiceHeader.controls.fromname.setValue(
        String('LINE DRIVE TRUCKING, INC.')
      )
      this.FormInvoiceHeader.controls.fromstreet.setValue(
        String('1231 N MILLER STREET, STE #150 ,ANAHEIM CA 93021')
      )
      this.FormInvoiceHeader.controls.toname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.tostreet.setValue(
        String('5942 EDIGER AVE. STE #113, HUNTINGTON BEACH CA 92649.')
      )
      this.FormInvoiceHeader.controls.billname.setValue(String(''))
      this.FormInvoiceHeader.controls.billstreet.setValue(String(''))
    } else if (Number(this.valorCustomerMasivo) == 1169) {
      this.FormInvoiceHeader.controls.fromname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.fromstreet.setValue(
        String('1231 N MILLER STREET STE #150 ,ANAHEIM CA 93021')
      )
      this.FormInvoiceHeader.controls.toname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.tostreet.setValue(
        String('5942 EDIGER AVE. STE #113 ,HUNTINGTON BEACH  CA 92649.')
      )
      this.FormInvoiceHeader.controls.billname.setValue(
        String('BIN CELLAR USA')
      )
      this.FormInvoiceHeader.controls.billstreet.setValue(
        String('696 SAN RAMON VALLEY BLVD STE 345 ,DANVILLE CA 94526')
      )
    } else if (Number(this.valorCustomerMasivo) == 1190) {
      this.FormInvoiceHeader.controls.fromname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.fromstreet.setValue(
        String('1231 N MILLER STREET STE #150 ,ANAHEIM CA 93021')
      )
      this.FormInvoiceHeader.controls.toname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.tostreet.setValue(
        String('5942 EDIGER AVE. STE #113 ,HUNTINGTON BEACH CA 92649.')
      )
      this.FormInvoiceHeader.controls.billname.setValue(
        String('COMPLETE SOLAR')
      )
      this.FormInvoiceHeader.controls.billstreet.setValue(String(''))
    } else if (Number(this.valorCustomerMasivo) == 379) {
      this.FormInvoiceHeader.controls.fromname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.fromstreet.setValue(
        String('1231 N MILLER STREET STE #150 ANAHEIM, CA 93021')
      )
      this.FormInvoiceHeader.controls.toname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.tostreet.setValue(
        String('5942 EDIGER AVE. STE #113 ,HUNTINGTON BEACH CA 92649.')
      )
      this.FormInvoiceHeader.controls.billname.setValue(String('KINGFA USA'))
      this.FormInvoiceHeader.controls.billstreet.setValue(
        String('47440 MICHIGAN AVE STE 100 ,CANTON MI48188')
      )
    } else if (Number(this.valorCustomerMasivo) == 1266) {
      this.FormInvoiceHeader.controls.fromname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.fromstreet.setValue(
        String('1231 N MILLER STREET STE #150 ,ANAHEIM CA 93021')
      )
      this.FormInvoiceHeader.controls.toname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.tostreet.setValue(
        String('5942 EDIGER AVE. STE #113 ,HUNTINGTON BEACH CA 92649.')
      )
      this.FormInvoiceHeader.controls.billname.setValue(String(''))
      this.FormInvoiceHeader.controls.billstreet.setValue(String(''))
    }else if (Number(this.valorCustomerMasivo) == 1297) {
      this.FormInvoiceHeader.controls.fromname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.fromstreet.setValue(
        String('1231 N MILLER STREET STE #150 ,ANAHEIM CA 93021')
      )
      this.FormInvoiceHeader.controls.toname.setValue(
        String('LINE DRIVE TRUCKING INC.')
      )
      this.FormInvoiceHeader.controls.tostreet.setValue(
        String('5942 EDIGER AVE. STE #113 ,HUNTINGTON BEACH CA 92649.')
      )
      this.FormInvoiceHeader.controls.billname.setValue(String('IAP West Inc'))
      this.FormInvoiceHeader.controls.billstreet.setValue(String('20036 S Via Baron,Rancho Dominguez CA 90220'))
    } else {
      if (this.authenticationService.currentUserValue.company == "LDT20") {
        this.FormInvoiceHeader.controls.fromname.setValue(
          String('LINE DRIVE TRUCKING INC.')
        )
        this.FormInvoiceHeader.controls.fromstreet.setValue(
          String('1231 N MILLER STREET STE #150 ,ANAHEIM CA 93021')
        )
        this.FormInvoiceHeader.controls.toname.setValue(
          String('')
        )
        this.FormInvoiceHeader.controls.tostreet.setValue(
          String('')
        )
        this.FormInvoiceHeader.controls.billname.setValue(String(''))
        this.FormInvoiceHeader.controls.billstreet.setValue(String(''))
      }  
    }
    this.FormInvoiceHeader.controls.tipo.setValue(Number('0'))
    this.FormInvoiceHeader.controls.type_order.setValue(String(this.valorTYPE))
    this.labelInvoiceHeaderButton = 'Save'
  }
  oncleaar () {
    
    this.FormInvoiceHeader.reset();
   
    this.valorCustomerMasivo=null;
    this.valorTYPE='RECEIVE-GENERAL'
this.valorTYPERate='1'
this.idorder=0
this.IdEditar=0
this.FormInvoiceHeader.controls.tipo.setValue(0)
    this.valorCustomerMasivo = ''
    this.FormInvoiceHeader.controls.tipo.setValue(Number('0'))
    this.FormInvoiceHeader.controls.type_order.setValue(String(this.valorTYPE))
    this.labelInvoiceHeaderButton = 'Save'
    this.IdEditar = 0
    this.idorder = 0
    this.ratemanual = false
    this.ratemanual2 = false
    this.rateamountmanuallyselect = []
    this.datosExportInvoice = []
    this.viewListInvoice = true
    this.viewListInvoice = true
    this.readonlyType = false
    this.invoiceexcelGenerar = false
    this.invoiceSearchView = false
    this.invoicechargesview = false
    this.invoicerateAddview = false
    this.invoicecollectionrateamount = []
    this.viewAddlistRate = false
    this.datosReceiverProducts = []
    this.receiverIDList = []

    this.arrayDatosChangeReceivinng = []
    this.rateamountmanuallyselect = []

    this.datosSearchReceiver = []
    this.containerList = []

    this.spinner.show();
    setTimeout(() => {
      this.onChangeInvoiceGeneral();
      this.spinner.hide();
    }, 1200);
  }
  oncleaar2 () {
   
        
    this.FormInvoiceHeader.reset();
   
    this.valorCustomerMasivo=null;
    this.valorTYPE='RECEIVE-GENERAL'
this.valorTYPERate='1'
    this.valorCustomerMasivo = ''
    this.FormInvoiceHeader.controls.tipo.setValue(Number('0'))
    this.FormInvoiceHeader.controls.type_order.setValue(String(this.valorTYPE))
    this.labelInvoiceHeaderButton = 'Save'
    this.IdEditar = 0
    this.idorder = 0
    this.ratemanual = false
    this.ratemanual2 = false
    this.rateamountmanuallyselect = []
    this.datosExportInvoice = []
    this.viewListInvoice = false
    this.viewListInvoice = false
    this.readonlyType = false
    this.invoiceexcelGenerar = false
    this.invoiceSearchView = false
    this.invoicechargesview = false
    this.invoicerateAddview = false
    this.viewAddlistRate = false
    this.invoicecollectionrateamount = []
    this.datosReceiverProducts = []
    this.receiverIDList = []

    this.arrayDatosChangeReceivinng = []
    this.rateamountmanuallyselect = []

    this.datosSearchReceiver = []
    this.containerList = []
    this.onNewInvoices()
 
  }
  pdfGenerate () {
    var url = ''
    if (this.valorTYPE == 'SHIPPING-GENERAL') {
      url +=
        environment.wmsdocument +
        `/Warehouse/invoiceGeneralShippingforDateRange?tblCustomerID=${Number(
          this.valorCustomerMasivo
        )}&tblCompanyID=${
          this.authenticationService.currentUserValue.companyIdWh
        }&from=${new Date(new Date(this.From)).toISOString()}&to=${new Date(
          new Date(this.To)
        ).toISOString()}&id_order=${this.idorder}&type_order=${
          this.valorTYPE
        }&typeRate=${Number(this.valorTYPERate)}`

      window.open(url)
    } else {
      url +=
        environment.wmsdocument +
        `/Warehouse/invoiceGeneralforDateRangeRateManuallity?tblCustomerID=${Number(
          this.valorCustomerMasivo
        )}&tblCompanyID=${
          this.authenticationService.currentUserValue.companyIdWh
        }&from=${new Date(new Date(this.From)).toISOString()}&to=${new Date(
          new Date(this.To)
        ).toISOString()}&id_order=${this.idorder}&type_order=${
          this.valorTYPE
        }&typeRate=${Number(this.valorTYPERate)}`

      window.open(url)
    }
  }
  onChangeInvoiceGeneral () {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/invoiceheadergeneralSelect?companyID=${Number(
          this.authenticationService.currentUserValue.companyIdWh
        )}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.invoiceheadergeneralSelect=[];


        this.invoiceheadergeneralSelect = response
      })
  }
  onEditarInvoice (row: any) {
    this.readonlyType = true
    this.FormInvoiceHeader.controls.tipo.setValue(Number(row.id_header))
    this.FormInvoiceHeader.controls.type_order.setValue(String(row.type_order))
    this.FormInvoiceHeader.controls.fromname.setValue(String(row.fromname))
    this.FormInvoiceHeader.controls.fromstreet.setValue(String(row.fromstreet))
    this.FormInvoiceHeader.controls.toname.setValue(String(row.toname))
    this.FormInvoiceHeader.controls.tostreet.setValue(String(row.tostreet))
    this.FormInvoiceHeader.controls.billname.setValue(String(row.billname))
    this.FormInvoiceHeader.controls.billstreet.setValue(String(row.billstreet))

    try {
      this.valorTYPE=String(row.type_order)
    } catch (error) {
      
    }
    this.FormInvoiceHeader.controls.invoicenumber.setValue(
      String(row.invoicenumber)
    )
    this.FormInvoiceHeader.controls.payterm.setValue(String(row.payterm))
    this.FormInvoiceHeader.controls.customerid.setValue(String(row.customerid))

    this.FormInvoiceHeader.controls.referencesnumber.setValue(
      String(row.referencesnumber)
    )

    try {
      this.FormInvoiceHeader.controls.dateinvoice.setValue(new Date(row.dateinvoice))
    } catch (error) {}

    this.FormInvoiceHeader.controls.totalamount.setValue(
      String(row.totalamount)
    )
    this.FormInvoiceHeader.controls.noteinvoice.setValue(
      String(row.noteinvoice)
    )
    this.idorder = Number(row.id_header)
    this.labelInvoiceHeaderButton = 'Update'
    this.FormInvoiceHeader.controls.tipo.setValue(this.idorder)

    try {
      this.From = new Date(row.fromdate)
    } catch (error) {}
    try {
      this.To = new Date(row.todate)
    } catch (error) {}
    try {
      this.valorCustomerMasivo = Number(row.customerid)
    } catch (error) {}

    try {
      this.valorTYPERate = String(row.typeRate)
    } catch (error) {}
    this.viewListInvoice = false
    try {
      this.OninvoicecollectionrateamountSelect(this.idorder)
      /// this.Onrateamountmanuallyselect(this.idorder)
    } catch (error) {}

    try {
      this.OnReceiverIDInvoiceList(this.idorder)
    } catch (error) {}
  }
  OnNewChanges () {
    this.selectInvoice = this.FormReceivingChanges.controls.invoiceListSelect.value

    var Rquest = {}
    Rquest['tipo'] = Number(this.IdEditNewChanges)
    Rquest['tblID'] = Number(this.FormReceivingChanges.controls.id.value)
    if (
      this.IdChargesDescuento == null ||
      this.IdChargesDescuento == undefined
    ) {
      Rquest['tblCompanyChargesID'] = null
    } else {
      Rquest['tblCompanyChargesID'] = Number(this.IdChargesDescuento)
    }
    Rquest['tblInvoiceListID'] = Number(this.selectInvoice.key)
    Rquest['tblInvoiceListDescription'] = this.selectInvoice.value
    Rquest['ChargeDescription'] = this.selectInvoice.value
    Rquest['UnitPrice'] = String(
      this.FormReceivingChanges.controls.priceUnit.value || 0.0
    )
    Rquest['Quantity'] = String(
      this.FormReceivingChanges.controls.QuantityChanges.value || 0.0
    )
    var tt = 0

    try {
      console.log(
        this.FormReceivingChanges.controls.TotalChangesR.value,
        this.descuentoCharges
      )
      tt =
        Number(this.FormReceivingChanges.controls.TotalChangesR.value) -
        Number(this.descuentoCharges)
    } catch (error) {}

    Rquest['Total'] = String(tt || 0.0)

    Rquest['QBIntegrated'] = 0
    Rquest['extra1'] = String(this.FormReceivingChanges.controls.extra1.value)
    Rquest['extra2'] = String(this.FormReceivingChanges.controls.extra2.value)
    Rquest['type_order'] = this.valorTYPE
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/ChargesInvoiceInsert`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.labelbuttonCharges = 'Add'
        // this.OnClearReceivingCharges()
        console.log(response)
        var idr=Number(this.FormReceivingChanges.controls.id.value)
        this.FormReceivingChanges.reset({
          invoiceListSelect: [''],
          priceUnit: [1],
          QuantityChanges: [1],
          TotalChangesR: [1],
          extra1: [''],
          extra2: [''],
          id: [idr]
        })
        
        this.OnChangeReceivingTable(this.FormReceivingChanges.controls.id.value)
      })
  }
  onChangeDa () {
    this.OnChangeReceivingTable(this.FormReceivingChanges.controls.id.value)
    this.invoicechargesview = true
  }

  OnChangeReceivingTable (data: any) {
    console.log(data)
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/InvoiceChangeSearch?id_order=${Number(
          data
        )}&type_order=${this.valorTYPE}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseReceivingChanges[]) => {
        try {
          this.arrayDatosChangeReceivinng = []
          if (response.length > 0) {
            for (let index = 0; index < response.length; index++) {
              const element = response[index]
              this.arrayDatosChangeReceivinng.push(element)
            }
          }
        } catch (error) {}
      })
  }
  OnChangeInvoiceList () {
    var Rquest = {}
    Rquest['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Rquest['active'] = 1
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/ReceivingInvoicelistSelect`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.invoiceList = response
      })
  }

  OnCustomerChargesDesc (data: any) {
    console.log(data)
    var Rquest = {}
    Rquest['company'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Rquest['customer'] = Number(this.valorCustomerMasivo)
    Rquest['invoice'] = Number(data.value.key)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/CustomerChargesSearchDescuento`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.IdChargesDescuento = Number(response[0].ChargesId)
          this.descuentoCharges = Number(response[0].total)
        } catch (error) {
          this.IdChargesDescuento = null
          this.descuentoCharges = 0
        }
      })
  }
  OnEditNewChanges (data: any) {
    this.IdEditNewChanges = data.ID
    this.FormReceivingChanges.controls.priceUnit.setValue(data.UnitPrice)
    this.FormReceivingChanges.controls.QuantityChanges.setValue(data.Quantity)
    this.FormReceivingChanges.controls.TotalChangesR.setValue(data.Total)
    //this.FormReceivingChanges.controls.QBIntegrated.setValue(data.QBIntegrated)
    var jj = this.filterDatainvoiceList(data.tblInvoiceListDescription)
    console.log(jj)
    this.FormReceivingChanges.controls.invoiceListSelect.setValue(jj[0])
    this.FormReceivingChanges.controls.extra1.setValue(data.extra1)
    this.FormReceivingChanges.controls.extra2.setValue(data.extra2)
    this.OnCustomerChargesDescS(jj[0].key)
    this.labelbuttonCharges = 'Update'
  }
  OndeletechargesInvoice (data: any) {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/InvoiceChangeDelete?id_order=${Number(data.ID)}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe(() => {
        this.onChangeDa()
      })
  }
  filterDatainvoiceList (locationName: string) {
    return this.invoiceList.filter(object => {
      if (object['value'] == locationName) {
        return object
      }
    })
  }
  
  OnOperacion () {
    this.FormReceivingChanges.controls.TotalChangesR.setValue(
      Number(this.FormReceivingChanges.controls.priceUnit.value) *
        Number(this.FormReceivingChanges.controls.QuantityChanges.value)
    )
  }
  OnClearReceivingCharges () {
    this.IdEditNewChanges = 0
    this.descuentoCharges = 0
    this.FormReceivingChanges.controls.priceUnit.setValue(0)
    this.FormReceivingChanges.controls.QuantityChanges.setValue(0)
    this.FormReceivingChanges.controls.TotalChangesR.setValue(0)
    //this.FormReceivingChanges.controls.QBIntegrated.setValue(null)

    this.FormReceivingChanges.controls.invoiceListSelect.setValue(null)
    this.FormReceivingChanges.controls.id.setValue(0)
    this.arrayDatosChangeReceivinng = []
    this.labelbuttonCharges = 'Add'
    this.invoicechargesview = false
  }
  OnCustomerChargesDescS (data: any) {
    console.log(data)
    var Rquest = {}
    Rquest['company'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Rquest['customer'] = Number(this.valorCustomerMasivo)
    Rquest['invoice'] = Number(data)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/CustomerChargesSearchDescuento`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.IdChargesDescuento = Number(response[0].ChargesId)
          this.descuentoCharges = Number(response[0].total)
        } catch (error) {
          this.IdChargesDescuento = null
          this.descuentoCharges = 0
        }
      })
  }

  OnAddInvoiceItems (valores: any) {
    var dataJson = {
      tipo: 0,
      receiveId: Number(valores.tblReceivingProductsID),
      id_invoice: Number(this.idorder),
      total_pallets: Number(valores.totalPallets),
      quantity: Number(valores.piecesByPallet),
      type_pallet: String(valores.type_pallets),
      itemaNumber: String(valores.itemNumber),
      itemdescriptions: String(valores.itemDescription),
      rate: Number(valores.rateamount),
      amount: Number(valores.piecesByPallet) * Number(valores.rateamount)
    }
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/RequestInvoiceitemsmanually`,
        dataJson,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe(() => {})
  }

  OnChangeDataInvoiceReceive () {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/invoiceGeneralforRatemanuallyDateRange?tblCustomerID=${Number(
          this.valorCustomerMasivo
        )}&tblCompanyID=${
          this.authenticationService.currentUserValue.companyIdWh
        }&from=${new Date(new Date(this.From)).toISOString()}&to=${new Date(
          new Date(this.To)
        ).toISOString()}&id_order=${this.idorder}&type_order=${
          this.valorTYPE
        }&typeRate=${Number(this.valorTYPERate)}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.datosExportInvoice = response
        console.log(this.datosExportInvoice, 'datosSelect')
      })
  }

  OnChangeDataInvoiceReceiveAddReceiver () {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/SearchReceiverProductsItemsGet?ID=${Number(
          this.idorderAddReceiver
        )}&typeRate=${Number(this.valorTYPERate2)}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.datosReceiverProducts = response
        this.OnChangeRateArrayTable(this.datosReceiverProducts)
      })
  }

  @ViewChild('excel2') table2: ElementRef
  exportAsExcelRate () {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table2.nativeElement
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx')
  }

  @ViewChild('tableSearchRece') tableSearchRece: ElementRef
  exportAsExceltableSearchRece () {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.tableSearchRece.nativeElement
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx')
  }
  @ViewChild('tableSearchReceCon') tableSearchReceCon: ElementRef
  exportAsExceltableSearchReceCon () {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.tableSearchReceCon.nativeElement
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx')
  }
  @ViewChild('excelreceiverId') table2Recei: ElementRef
  exportAsExcelRateReceiver () {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table2Recei.nativeElement
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx')
  }
  onChangeDataInvoiceIetems () {
    console.log(this.datosExportInvoice)

    for (
      let index = 0;
      index < this.datosExportInvoice.invoiceGeneralRequest.length;
      index++
    ) {
      const element = this.datosExportInvoice.invoiceGeneralRequest[index]
      for (
        let index2 = 0;
        index2 < element.responseInvoiceItemsManuallity.length;
        index2++
      ) {
        const element2 = element.responseInvoiceItemsManuallity[index2]
        this.OnAddInvoiceItems(element2)
        this.OnReceiverIDInvoiceListAdd(
          this.idorder,
          Number(element2.tblReceivingProductsID),
          1
        )
      }
    }
    try {
      setTimeout(() => {
        this.Onrateamountmanuallyselect(this.idorder)
        this.OnReceiverIDInvoiceList(this.idorder)
      }, 1500)
    } catch (error) {}
  }
  onChangeDataInvoiceIetemsReceiverID () {
    console.log(this.datosExportInvoiceReceiver)

    for (
      let index = 0;
      index < this.datosExportInvoiceReceiver.invoiceGeneralRequest.length;
      index++
    ) {
      const element = this.datosExportInvoiceReceiver.invoiceGeneralRequest[
        index
      ]
      for (
        let index2 = 0;
        index2 < element.responseInvoiceItemsManuallity.length;
        index2++
      ) {
        const element2 = element.responseInvoiceItemsManuallity[index2]
        this.OnAddInvoiceItems(element2)
      }
    }
    this.OnReceiverIDInvoiceListAdd(
      this.idorder,
      Number(this.idorderAddReceiver),
      1
    )

    this.datosExportInvoiceReceiver = null

    try {
      setTimeout(() => {
        //   this.Onrateamountmanuallyselect(this.idorder)
        this.OnReceiverIDInvoiceList(this.idorder)
      }, 1500)
    } catch (error) {}
  }

  OnAddInvoiceItems2 (valores: any) {
    var dataJson = {
      tipo: Number(valores.id_manually),
      receiveId: Number(valores.receiveId),
      id_invoice: Number(this.idorder),
      total_pallets: Number(valores.total_pallets),
      quantity: Number(valores.Quantity),
      type_pallet: String(valores.type_pallet),
      itemaNumber: String(valores.itemaNumber),
      itemdescriptions: String(valores.itemdescriptions),
      rate: Number(valores.rate),
      amount: Number(valores.Quantity) * Number(valores.rate)
    }
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/RequestInvoiceitemsmanually`,
        dataJson,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe(() => {})
  }
  onChangeDataInvoiceIetems2 () {
    for (let index = 0; index < this.rateamountmanuallyselect.length; index++) {
      const element = this.rateamountmanuallyselect[index]
      this.OnAddInvoiceItems2(element)
    }
    try {
      setTimeout(() => {
        this.Onrateamountmanuallyselect(this.idorder)
      }, 1500)
    } catch (error) {}
  }
  Onrateamountmanuallyselect (vaalor: any) {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/rateamountmanuallyselect?idinvoice=${Number(vaalor)}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.rateamountmanuallyselect = response

        try {
          if (this.rateamountmanuallyselect.length > 0) {
            this.ratemanual = false
            this.ratemanual2 = true
            this.valorTYPERate = '4'
            this.btnExport = false
          } else {
            if (this.valorTYPERate == '4') {
              this.ratemanual = true
              this.ratemanual2 = false
              this.btnExport = false
            } else {
              this.ratemanual = false
              this.btnExport = true
            }
          }
        } catch (error) {
          if (this.valorTYPERate == '4') {
            this.ratemanual = true
            this.ratemanual2 = false
            this.btnExport = false
          } else {
            this.ratemanual = false
            this.btnExport = true
          }
        }
      })
  }

  OnReceiverIDInvoiceList (receiverId: any) {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/receiverIdadditionalmultiplecustomerselectGet?idinvoice=${Number(
          receiverId
        )}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.receiverIDList = response
      })
  }
  OnReceiverIDInvoiceListDelete (receiverId: any) {
    this.spinner.show()
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/receiverIdadditionalmultiplecustomerDelete?idinvoice=${Number(
          receiverId.InvoiceId
        )}&receiverID=${Number(receiverId.receiverID)}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe(() => {
        this.spinner.hide()
        this.OnReceiverIDInvoiceList(receiverId.InvoiceId)
        try {
          this.OninvoicecollectionrateamountSelect(this.idorder)
        } catch (error) {}
      })
  }

  OnReceiverIDInvoiceListAdd (invoice: any, receiverId: any, active: any) {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/receiverIdadditionalmultiplecustomerAdd?idinvoice=${Number(
          invoice
        )}&receiverID=${Number(receiverId)}&active=${Number(active)}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe(() => {})
  }

  onClearAddReceiver () {
    this.datosReceiverProducts = []
    this.invoicerateAddview = false
    this.idorderAddReceiver = ''
    this.invoiceSearchView = true
    this.RequestAddRateReceiverArray = []
  }

  OnChangeDataInvoiceReceiveSearch () {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/invoiceGeneralforRatemanuallyDateRangeSearch?tblCustomerID=${Number(
          this.valorCustomerMasivo2
        )}&tblCompanyID=${
          this.authenticationService.currentUserValue.companyIdWh
        }&from=${new Date(new Date(this.From2)).toISOString()}&to=${new Date(
          new Date(this.To2)
        ).toISOString()}&type_order=${this.valorTYPE2}&typeRate=${Number(
          this.valorTYPERate2
        )}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.datosSearchReceiver=[];
        this.datosSearchReceiver = response
      })
  }

  OnsaveTipoSearchInvoice () {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/invoiceSearchDataSaveGet?id_order=${Number(
          this.idorder
        )}&from2=${new Date(new Date(this.From)).toISOString()}&to2=${new Date(
          new Date(this.To)
        ).toISOString()}&type_order2=${this.valorTYPE}&typeRate2=${Number(
          this.valorTYPERate
        )}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
       
      })
  }
  OnChangeDataInvoiceContainerSearch () {
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/SearchConteinerGet?companyId=${
          this.authenticationService.currentUserValue.companyIdWh
        }&from=${new Date(new Date(this.From2)).toISOString()}&to=${new Date(
          new Date(this.To2)
        ).toISOString()}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.containerList=[];
        this.containerList = response
        console.log(this.containerList)
      })
  }

  onselectReceiver (numero: any) {
    this.idorderAddReceiver = String(numero)
    this.datosReceiverProducts = []
    this.invoicerateAddview = true
    this.invoiceSearchView = false
    this.OnChangeDataInvoiceReceiveAddReceiver()
  }
  OnSaveRateNew () {
    this.spinner.show()
    console.log(this.lessons)
    this.invoicerateAddview = false
    for (let index = 0; index < this.lessons.value.length; index++) {
      const element = this.lessons.value[index]
      console.log(element)
      this.OnAddRateEndpoint(element)
    }
    try {
      this.lessons.clear();
    } catch (error) {
      
    }
    for (let index = 0; index < this.lessons.value.length; index++) {
      this.lessons.removeAt(index)
    }

    console.log(this.lessons)
    this.RequestAddRateReceiverArray = []
    this.datosReceiverProducts = []
    this.OnReceiverIDInvoiceListAdd(
      this.idorder,
      Number(this.idorderAddReceiver),
      1
    )

    try {
      setTimeout(() => {
        this.spinner.hide()
        this.spinner.show()
if (this.valorTYPE2=='CONTAINER-GENERAL') {
  this.OnChangeDataInvoiceContainerSearch();
} else {
  this.OnChangeDataInvoiceReceiveSearch()
}


      setTimeout(() => {
         
        this.OninvoicecollectionrateamountSelect(this.idorder)
        this.OnReceiverIDInvoiceList(this.idorder)
        this.invoiceSearchView = true
        this.spinner.hide()
      }, 1200);
       
      }, 1500)
    } catch (error) {
      this.spinner.hide()
    }

    /* 
   
for (let index = 0; index < this.RequestAddRateReceiverArray.length; index++) {
  const element = this.RequestAddRateReceiverArray[index];
  
}
 */
  }
  OnAddRateEndpoint (dataAr: any) {
    console.log(dataAr)
    var jsonData = {
      td_charges: 0,
      idInvoice: Number(this.idorder),
      numero: Number(dataAr.numero),
      id: Number(dataAr.id),
      recID: Number(dataAr.recID),
      customerID: Number(dataAr.customerID),
      customer: String(dataAr.customer),
      itemNumber: String(dataAr.itemNumber),
      description: String(dataAr.description),
      pallets: Number(dataAr.pallets),
      piecesByPallet: Number(dataAr.piecesByPallet),
      total: Number(dataAr.total),
      poNumber: String(dataAr.poNumber),
      received: new Date(dataAr.received),
      logo: String(dataAr.logo),
      weight_pllets: Number(dataAr.weight_pllets),
      type_pallets: String(dataAr.type_pallets),
      notes: String(dataAr.notes),
      carrierName: String(dataAr.carrierName),
      bolNumber: String(dataAr.bolNumber),
      referenceNumber: String(dataAr.referenceNumber),
      receivedDate: new Date(dataAr.receivedDate),
      idReceiving: Number(dataAr.idReceiving),
      containerNumber: String(dataAr.containerNumber),
      rowPosition: Number(dataAr.rowPosition),
      rateAmount: Number(dataAr.rateAmount),
      amount: Number(dataAr.amount)
    }
    //var jsonData=dataAr
    console.log(jsonData)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/AddReceiverProductscollectionrateamount`,
        jsonData,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        console.log(response)
      })
  }
  OninvoicecollectionrateamountSelect (order: any) {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/invoicecollectionrateamountSelect?idinvoice=${Number(
          order
        )}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseRateInvoiceNumber[]) => {
        this.invoicecollectionrateamount = response
        try {
          if (this.invoicecollectionrateamount.length > 0) {
            this.viewAddlistRate = true
          } else {
            this.viewAddlistRate = false
          }
        } catch (error) {}
      })
  }
  onNewInvoices () {
    this.FormInvoiceHeader.reset();
    this.viewListInvoice = false
    this.valorCustomerMasivo=null;
    this.valorTYPE='RECEIVE-GENERAL'
this.valorTYPERate='1'
this.idorder=0
this.IdEditar=0
this.FormInvoiceHeader.controls.tipo.setValue(0)
    this.invoicecollectionrateamount = null
    this.datosReceiverProducts = null
    this.receiverIDList = null

    this.arrayDatosChangeReceivinng = null
    this.rateamountmanuallyselect = null

    this.datosSearchReceiver = null
    this.containerList = null
    this.invoiceheaderprefixSelect();
  }

  OnSaveRateNewUpdate () {
    this.spinner.show()
    for (
      let index = 0;
      index < this.invoicecollectionrateamount.length;
      index++
    ) {
      const element = this.invoicecollectionrateamount[index]
      this.OnAddRateEndpointUpdate(element)
    }
    this.invoicecollectionrateamount = []
    //this.OnReceiverIDInvoiceListAdd(this.idorder,Number(this.idorderAddReceiver),1)
    try {
      setTimeout(() => {
        this.spinner.hide()
        this.OninvoicecollectionrateamountSelect(this.idorder)
        this.OnReceiverIDInvoiceList(this.idorder)
      }, 1500)
    } catch (error) {}
  }
  OnAddRateEndpointUpdate (dataAr: any) {
    console.log(dataAr)
    var jsonData = {
      td_charges: Number(dataAr.Td_charges),
      idInvoice: Number(this.idorder),
      numero: Number(dataAr.numero),
      id: Number(dataAr.ReceiveProductsItemsID),
      recID: Number(dataAr.recID),
      customerID: Number(dataAr.CustomerID),
      customer: String(dataAr.Customer),
      itemNumber: String(dataAr.ItemNumber),
      description: String(dataAr.Description),
      pallets: Number(dataAr.Pallets),
      piecesByPallet: Number(dataAr.PiecesByPallet),
      total: Number(dataAr.Total),
      poNumber: String(dataAr.PONumber),
      received: new Date(dataAr.Received),
      logo: String(dataAr.logo),
      weight_pllets: Number(dataAr.weight_pllets),
      type_pallets: String(dataAr.type_pallets),
      notes: String(dataAr.Notes),
      carrierName: String(dataAr.CarrierName),
      bolNumber: String(dataAr.BOLNumber),
      referenceNumber: String(dataAr.ReferenceNumber),
      receivedDate: new Date(dataAr.ReceivedDate),
      idReceiving: Number(dataAr.IDReceiving),
      containerNumber: String(dataAr.ContainerNumber),
      rowPosition: Number(dataAr.rowPosition),
      rateAmount: Number(dataAr.rate_amount),
      amount: Number(dataAr.amount)
    }
    console.log(jsonData)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/AddReceiverProductscollectionrateamount`,
        jsonData,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        console.log(response)
      })
  }

  onAddSearchRate (data: any) {
    try {
      this.lessons.clear();
    } catch (error) {
      
    }
    this.invoicecustomerchargeTotalSelect(data.tblCustomerID);
    try {
      for (let index = 0; index < this.lessons.value.length; index++) {
        this.lessons.removeAt(index)
      }
    } catch (error) {}

    this.idorderAddReceiver = String(data.ID)
    this.datosReceiverProducts = []
    this.invoicerateAddview = true
    this.invoiceSearchView = false
    this.OnChangeDataInvoiceReceiveAddReceiver()
  }
  onviewsSearch () {
    if (this.invoiceSearchView) {
      this.invoiceSearchView = false
    } else {
      this.invoiceSearchView = true
    }
  }

  onAddChargerInvoice (data: any) {
  
    this.FormReceivingChanges.reset({
      invoiceListSelect: [''],
      priceUnit: [1],
      QuantityChanges: [1],
      TotalChangesR: [1],
      extra1: [''],
      extra2: [''],
      id: [Number(data)]
    })
    this.FormReceivingChanges.controls.id.setValue(data)
    this.onChangeDa()
  }

  onviewsAddCharges () {
    if (this.invoicechargesview) {
      this.invoicechargesview = false
    } else {
      this.invoicechargesview = true
    }
  }
  onviewsexcelgenerar () {
    if (this.invoiceexcelGenerar) {
      this.invoiceexcelGenerar = false
    } else {
      this.invoiceexcelGenerar = true
    }
  }

  OnChangeRateArrayTable (array: any) {
    this.RequestAddRateReceiverArray = []
    this.lessons.clear()
    for (let index = 0; index < array.length; index++) {
      console.log("OnChangeRateArrayTable",this.dataResponseinvoicecustomerchargeSelect)
      const element = array[index]
      var am=0
      var ra=0
      if (Number(this.valorTYPERate2)!=4) {
        try {
          am=Number(element.Pallets)*Number(element.rateAmount)
        } catch (error) {
          am=0
        } 
        this.RequestAddRateReceiver = {
          td_charges: 0,
          idInvoice: this.idorder,
          numero: Number(element.numero),
          id: Number(element.ID),
          recID: Number(element.recID),
          customerID: Number(element.CustomerID),
          customer: String(element.Customer),
          itemNumber: String(element.ItemNumber),
          description: String(element.Description),
          pallets: Number(element.Pallets),
          piecesByPallet: Number(element.PiecesByPallet),
          total: Number(element.Total),
          poNumber: String(element.PONumber),
          received: new Date(element.Received),
          logo: String(element.logo),
          weight_pllets: Number(element.weight_pllets),
          type_pallets: String(element.type_pallets),
          notes: String(element.Notes),
          carrierName: String(element.CarrierName),
          bolNumber: String(element.BOLNumber),
          referenceNumber: String(element.ReferenceNumber),
          receivedDate: new Date(element.ReceivedDate),
          idReceiving: Number(element.IDReceiving),
          containerNumber: String(element.ContainerNumber),
          rowPosition: Number(element.rowPosition),
          rateAmount: Number(element.rateAmount),
          amount: am
        }
      }else{
        try {
          ra=Number(this.dataResponseinvoicecustomerchargeSelect.total)
        } catch (error) {
          ra=0
        } 
        try {
          am=Number(element.Pallets)*Number(ra)
        } catch (error) {
          am=0
        }
        this.RequestAddRateReceiver = {
          td_charges: 0,
          idInvoice: this.idorder,
          numero: Number(element.numero),
          id: Number(element.ID),
          recID: Number(element.recID),
          customerID: Number(element.CustomerID),
          customer: String(element.Customer),
          itemNumber: String(element.ItemNumber),
          description: String(element.Description),
          pallets: Number(element.Pallets),
          piecesByPallet: Number(element.PiecesByPallet),
          total: Number(element.Total),
          poNumber: String(element.PONumber),
          received: new Date(element.Received),
          logo: String(element.logo),
          weight_pllets: Number(element.weight_pllets),
          type_pallets: String(element.type_pallets),
          notes: String(element.Notes),
          carrierName: String(element.CarrierName),
          bolNumber: String(element.BOLNumber),
          referenceNumber: String(element.ReferenceNumber),
          receivedDate: new Date(element.ReceivedDate),
          idReceiving: Number(element.IDReceiving),
          containerNumber: String(element.ContainerNumber),
          rowPosition: Number(element.rowPosition),
          rateAmount:ra,
          amount:am
        }



      }
      this.RequestAddRateReceiverArray.push(this.RequestAddRateReceiver)
      this.addLessonFor(this.RequestAddRateReceiver)
    }
  }

  get lessons () {
    return this.formArrayDataRate.controls['rateListForm'] as FormArray
  }

  addLesson () {
    const lessonForm = this.formbuider.group({
      td_charges: [0],
      idInvoice: [Number(this.idorder)],
      numero: [1],
      id: [0],
      recID: [0],
      customerID: [0],
      customer: [''],
      total: [0],
      poNumber: [''],
      received: [new Date(new Date())],
      logo: [''],
      weight_pllets: [0],
      notes: [''],
      bolNumber: [''],
      referenceNumber: [''],
      receivedDate: [new Date(new Date())],
      idReceiving: [this.idorderAddReceiver],
      containerNumber: [''],

      rowPosition: [''],
      itemNumber: [''],
      description: [''],
      pallets: [''],
      type_pallets: [''],
      piecesByPallet: [''],
      rateAmount: [''],
      amount: [''],
      carrierName: ['']
    })
    this.lessons.push(lessonForm)
  }
  addLessonFor (dataAr: any) {
    const lessonForm = this.formbuider.group({
      td_charges: [0],
      idInvoice: [Number(this.idorder)],
      numero: [Number(dataAr.numero)],
      id: [Number(dataAr.id)],
      recID: [Number(dataAr.recID)],
      customerID: [Number(dataAr.customerID)],
      customer: [String(dataAr.customer)],
      total: [Number(dataAr.total)],
      poNumber: [String(dataAr.poNumber)],
      received: [new Date(dataAr.received)],
      logo: [String(dataAr.logo)],
      weight_pllets: [Number(dataAr.weight_pllets)],
      notes: [String(dataAr.notes)],
      bolNumber: [String(dataAr.bolNumber)],
      referenceNumber: [String(dataAr.referenceNumber)],
      receivedDate: [new Date(dataAr.receivedDate)],
      idReceiving: [Number(dataAr.idReceiving)],
      containerNumber: [String(dataAr.containerNumber)],

      rowPosition: [Number(dataAr.rowPosition)],
      itemNumber: [String(dataAr.itemNumber)],
      description: [String(dataAr.description)],
      pallets: [Number(dataAr.pallets)],
      type_pallets: [String(dataAr.type_pallets)],
      piecesByPallet: [Number(dataAr.piecesByPallet)],
      rateAmount: [Number(dataAr.rateAmount)],
      amount: [Number(dataAr.amount)],
      carrierName: [String(dataAr.carrierName)]
    })
    this.lessons.push(lessonForm)
  }
  deleteLesson (lessonIndex: number) {
    this.lessons.removeAt(lessonIndex)
  }
  invoiceheaderprefixSelect () {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/invoiceheaderprefixSelect?companyId=${Number(
          this.authenticationService.currentUserValue.companyIdWh
        )}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseinvoiceheaderprefixSelect) => {
        this.dataResponseinvoiceheaderprefixSelect=response;
        if(response.invoicePrefix.length>0){
          this.FormInvoiceHeader.controls.invoicenumber.setValue(`${response.invoicePrefix}-${response.invoiceNumber}`)
        


        }  else{

          this.FormInvoiceHeader.controls.invoicenumber.setValue(`${response.invoiceNumber}`)
        


        }
        this.invoiceheaderprefixUpdate();
      })
  }
  invoicecustomerchargeSelect (tblCustomerId) {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/invoicecustomerchargeSelect?tblCustomerId=${Number(
          tblCustomerId
        )}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseinvoicecustomerchargeSelect) => {
  // this.dataResponseinvoicecustomerchargeSelect=response;

      })
  }
  invoicecustomerchargeTotalSelect (tblCustomerId) {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/invoicecustomerchargeTotalSelect?tblCustomerId=${Number(
          tblCustomerId
        )}`,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseinvoicecustomerchargeTotalSelect) => {
   this.dataResponseinvoicecustomerchargeSelect=response;

      })
  }
  invoiceheaderprefixUpdate () {
var js={
  "companyId": Number(this.authenticationService.currentUserValue.companyIdWh),
  "invoiceNumber": Number(this.dataResponseinvoiceheaderprefixSelect.invoiceNumber)+1
};
    
    


    this._httpClient
      .put<any>(
        `${
          environment.apiUrl
        }/Administracion/invoiceheaderprefixUpdate`,js,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {

          
      })
  }
}
